import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";

export default function MentionsLegales() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Mentions Légales | Dépan'Volets Strasbourg"
        description="Mentions légales Dépan'Volets Strasbourg. Éditeur DF PRO, hébergeur, propriété intellectuelle et RGPD. 82 Rue de Heidenberg, 67200 Strasbourg."
        path="/mentions-legales"
        type="website"
        robots="noindex, follow"
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Mentions légales" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Mentions légales" }]} />
      <main>
        <header className="bg-[#143A66] text-white py-20 md:py-24">
          <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">
              Mentions légales
            </h1>
            <p className="text-white/80 text-base md:text-lg">
              Informations légales obligatoires concernant le site Dépan'Volets Strasbourg.
            </p>
          </div>
        </header>

        <DiagnosticVideo />

        <section className="bg-white py-14 md:py-20">
          <div className="max-w-4xl mx-auto px-4 md:px-8">
            <article className="space-y-12 text-brand-text leading-relaxed">
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">1. Éditeur du site</h2>
                <p className="mb-2"><strong>Raison sociale :</strong> DF PRO, SAS</p>
                <p className="mb-2"><strong>Forme juridique :</strong> Société par actions simplifiée</p>
                <p className="mb-2"><strong>SIREN :</strong> 984 775 262</p>
                <p className="mb-2"><strong>SIRET (siège) :</strong> 984 775 262 00020</p>
                <p className="mb-2"><strong>Numéro de TVA intracommunautaire :</strong> FR96 984 775 262</p>
                <p className="mb-2"><strong>Code NAF / APE :</strong> 43.32A — Travaux de menuiserie bois et PVC</p>
                <p className="mb-2"><strong>Siège social :</strong> 100 Route de Nîmes, 30132 Caissargues, France</p>
                <p className="mb-2"><strong>Atelier Strasbourg :</strong> <strong>82 Rue de Heidenberg, 67200 Strasbourg</strong>, France</p>
                <p className="mb-2"><strong>Téléphone :</strong>{" "}<a href="tel:0374473240" className="text-brand-blue hover:underline">03 74 47 32 40</a></p>
                <p className="mb-2"><strong>E-mail :</strong>{" "}<a href="mailto:contact@depanvolets-strasbourg.fr" className="text-brand-blue hover:underline">contact@depanvolets-strasbourg.fr</a></p>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">2. Directeur de la publication</h2>
                <p>Le directeur de la publication est le représentant légal de DF PRO.</p>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">3. Hébergeur du site</h2>
                <p className="mb-2"><strong>Hébergeur :</strong> OVH SAS</p>
                <p className="mb-2"><strong>Adresse :</strong> 2 rue Kellermann, 59100 Roubaix, France</p>
                <p><strong>Téléphone :</strong> 1007</p>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">4. Propriété intellectuelle</h2>
                <p className="mb-4">L'ensemble du contenu du site Dépan'Volets (textes, images, logos, etc.) est protégé par le droit de la propriété intellectuelle. Toute reproduction sans autorisation écrite est interdite.</p>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">5. Données personnelles et RGPD</h2>
                <p className="mb-4">Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression, de limitation et de portabilité de vos données. Les données collectées via les formulaires ne sont pas transmises à des tiers.</p>
                <p>Pour exercer vos droits : <a href="mailto:contact@depanvolets-strasbourg.fr" className="text-brand-blue hover:underline">contact@depanvolets-strasbourg.fr</a> — 82 Rue de Heidenberg, 67200 Strasbourg.</p>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">6. Cookies</h2>
                <p>Le site utilise uniquement des cookies techniques. Aucun cookie de traçage publicitaire n'est déposé sans votre consentement.</p>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">7. Droit applicable</h2>
                <p>Les présentes mentions légales sont régies par le droit français. Tribunal compétent : Strasbourg.</p>
              </div>
            </article>
          </div>
        </section>
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}